import React, { useState } from 'react';
import { ICON_NEW } from '../extras/icons';
import MainContent from '../layout/MainContent';
import TurnList from './turns/TurnList';
import TurnForm from './turns/TurnForm';
//Redux
import { useDispatch, useSelector } from 'react-redux';
import { addTurnsAction } from '../../actions/turnsActions';
import AuthoritiesService from '../../services/AuthoritiesService';
import { PARAMETROS_CREAR, TURNOS_CREAR } from '../../data/objects';
//Función principal
const Turns = () => {
    //Inicializo el state local
    const [show, setShow] = useState(false);
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Tomo el store
    const authorities = useSelector(state => state.auth.authorities);
    //Manejo el insert
    const handleCreate = () => {
        //Llamo al dispatch
        dispatch( addTurnsAction(handleOpen) );
    }
    //Nodos
    const nodes = [];
    //Actions
    const actions = [{
        title: 'NUEVO',
        css: 'success',
        icon: <ICON_NEW className="fa-sm text-white-50" />,
        handle: handleCreate,
        granted: authorities && AuthoritiesService.hasPermission(authorities, TURNOS_CREAR)
    }];
    //Manejo la apertura de la ventana
    const handleOpen = () => {
        setShow(true);
    }
    //Manejo el cierre de la ventana
    const handleClose = () => {
        setShow(false);
    }
    //Renderizo
    return (
        <React.Fragment>
            <MainContent 
                title='Turnos' 
                subtitle='Administración' 
                nodes={nodes}
                actions={actions}
                component={TurnList}
                handleOpen={handleOpen}
                handleClose={handleClose}
            />

            <TurnForm
                show={show}
                handleClose={handleClose}
            />
        </React.Fragment>
    );
};

export default Turns;